<template>
    <div>
        <ValidationObserver ref="formModalValidate">
           <b-row>
                <b-col cols="12" md="6">
                  <ValidationProvider name="student_club_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_name')">
                            <student-club-selectbox :validateError="errors[0]"
                                                    v-model="form.student_club_id"
                                                    @club-selected="handleClubSelection"
                                                    :state="errors[0] ? false : null">
                            </student-club-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="form.academic_year">
                            </academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_date')">
                            <select-date :is-time="true" v-model="form.start_date" :validation-error="errors[0]" :time="true"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('end_date')">
                            <select-date :is-time="true" v-model="form.end_date" :validation-error="errors[0]" :time="true"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="form.status" code="student_club_president_application_statuses" :validate-error="errors[0]"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button
                    @click="updateForm"
                    type="button"
                    :disabled="formLoading"
                    variant="primary"
                    class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
    import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubService from "@/services/StudentClubService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            ParameterSelectbox,
            StudentClubSelectbox,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    //
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                StudentClubService.getPresident(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    this.form.dues = parseFloat(this.form.dues).toFixed(2);
                    if (this.form.status === 'p') {
                        this.form.status = 0;
                    } else if (this.form.status === 'a') {
                        this.form.status = 1;
                    }
                    StudentClubService.updatePresident(this.formId, this.form)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            },
            handleClubSelection(clubData) {
                if (clubData && clubData.dues) {
                    this.form.dues = parseFloat(clubData.dues)
                } else {
                    this.form.dues = 0;
                }
            },
        }
    }
</script>
